import React, { Component } from 'react';

import ComprobanteDownloadActions from './ComprobanteDownloadActions';
import PopConfirm from '../../../../../facturotopia/popconfirm/PopConfirm';

class SingleComprobanteActions extends Component {
  state = {
    showConfirm: false,
  };

  render() {
    const { showConfirm } = this.state;
    const { data } = this.props;

    return (
      <>
        {showConfirm && (
          <PopConfirm
            variant="inline"
            text="¿Cancelar la factura?"
            onAction={this.handleOnAction}
          />
        )}

        {!showConfirm && (
          <>
            <div className="d-inline-block mr-2">
              <ComprobanteDownloadActions data={data} />
            </div>
          </>
        )}
      </>
    );
  }
}

export default SingleComprobanteActions;
